"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = exports.default = void 0;
var _redux = require("redux");
var _actionify = require("@mulesoft/actionify");
var _assets = require("../domains/assets");
var _categories = require("../domains/categories");
var _identities = require("../domains/identities");
var _pages = require("../domains/pages");
var _portals = require("../domains/portals");
var _reviews = require("../domains/reviews");
var _session = require("../domains/session");
var _reducerManager = require("./reducerManager");
var reducers = exports.reducers = {
  actionify: _actionify.reducer,
  assets: _assets.reducer,
  categories: _categories.reducer,
  identities: _identities.reducer,
  pages: _pages.reducer,
  portals: _portals.reducer,
  reducerManager: _reducerManager.reducer,
  reviews: _reviews.reducer,
  session: _session.reducer
};
var _default = exports.default = function _default() {
  return (0, _redux.combineReducers)(reducers);
};
//# sourceMappingURL=reducers.js.map